export default "__VITE_ASSET__aGj4HCO3__"